// Traducciones en inglés para el formulario de opiniones
const opinionForm = {
  title: "Give Us Your Feedback!",
  alerts: {
    thankYou: "Thank you for your feedback!",
    error: "There was a problem submitting your data.",
  },
  buttons: {
    submit: "Submit",
    back: "Back",
  },
  question1: {
    label: "1. Gender *",
    option1: "Male",
    option2: "Female",
    option3: "Other",
    error: "This field is required.",
  },
  question2: {
    label: "2. Age (years) *",
    error: "Please enter a valid age.",
  },
  question3: {
    label: "3. Postal Code (ZIP) *",
    error: "Please enter a valid postal code (5 digits).",
  },
  question4: {
    label: "4. Have you read the comic in digital format or printed on paper? *",
    option1: "Digital",
    option2: "Printed",
    error: "This field is required.",
  },
  question5: {
    label: "5. Are you a regular comic reader?",
    description:
      "Rate from 1 to 5, where 1 means <bold>Never</bold> and 5 means <bold>Every day</bold>.",
    error: "This field is required.",
  },
  question6: {
    label: "6. Have you ever been to the place/monument where the story takes place? *",
    option1: "Yes",
    option2: "No",
    error: "This field is required.",
  },
  question7: {
    label: "7. Were you familiar with the place/monument? *",
    option1: "Yes",
    option2: "No",
    error: "This field is required.",
  },
  question8: {
    label: "8. Would you like to visit the place now that you have read the comic?",
    description:
      "Rate from 1 to 5, where 1 means <bold>I would not visit it</bold> and 5 means <bold>Definitely yes</bold>.",
    error: "This field is required.",
  },
  emotionsGroup: {
    label: "9. Evaluate the emotions that the monument where the story takes place evokes in you.",
  },
  question9: {
    description:
      "Rate from 1 to 5, where 1 means <bold>Indifference</bold> and 5 means <bold>Curiosity</bold>.",
    error: "This field is required.",
  },
  question10: {
    description:
      "Rate from 1 to 5, where 1 means <bold>Disdain</bold> and 5 means <bold>Pride</bold>.",
    error: "This field is required.",
  },
  question11: {
    description:
      "Rate from 1 to 5, where 1 means <bold>Vulnerability of the monument</bold> and 5 means <bold>Durability</bold>.",
    error: "This field is required.",
  },
  question12: {
    label: "10. How did you find the reading time? *",
    option1: "Short",
    option2: "Adequate",
    option3: "Long",
    error: "This field is required.",
  },
  question13: {
    label: "11. Are Zaquiel's flashbacks (memories of the past) well understood? *",
    option1: "Yes",
    option2: "No",
    error: "This field is required.",
  },
  question14: {
    label: "12. Do you prefer digital or printed comics? *",
    option1: "Digital",
    option2: "Printed",
    option3: "Both (Indifferent)",
    option4: "No Preference",
    error: "This field is required.",
  },
  question15: {
    label: "13. Would you like to know how Zaquiel's adventures continue? *",
    description:
      "Rate from 1 to 5, where 1 means Absolutely not and 5 means Without a doubt yes",
    error: "This field is required.",
  },
  question16: {
    label: "14. Do you think the comic's narrative helps in understanding the monument? *",
    description:
      "Rate from 1 to 5, where 1 means Not at all and 5 means Completely sure",
    error: "This field is required.",
  },
  question17: {
    label: "15. Comments (optional)",
  },
  chapter: {
    label: "16. Which chapter does your feedback refer to? *",
    option1: "Chapter 1",
    option2: "Chapter 2",
    option3: "Chapter 3",
    option4: "Chapter 4",
    option5: "Chapter 5",
    option6: "Chapter 6",
    option7: "Chapter 7",
    option8: "Chapter 8",
    option9: "Chapter 9",
    error: "Please select a chapter.",
  },
  gdpr: {
    label: "I agree to the processing and storage of my data in accordance with the Privacy Policy *",
    error: "You must agree to the data processing to continue.",
  },
};

export default opinionForm; 